import React, { useState } from "react";

import ProgramRating from "../../components/shared/programRating";
import CarbonFootprintIcon from "../../images/icons/carbon-neutral-icon.inline.svg";
import FundraisingSummary from "../cards/fundraisingSummary";
import GviFlexTestimonialRating from "../cards/gviFlexTestimonialRating";
import Image from "../image";
import ProgramCapacity from "../shared/programCapacity";

const ProgramSummaryDetails = ({
  programCode,
  programDuration,
  programTypeList,
  programTypes,
  programPopular,
  programCapacity,
  summaryDetailsClass,
  currentBrand,
  carbonFootprintStatus,
  scrollToReviews,
  programRatingDarkRatingIconClass,
  programRatingDarkRatingLogoClass,
  textColorClass = "text-black-lighter dark:text-white",
  textSecondaryColorClass = "text-black-lighter dark:text-gray-generic",
  iconClass = "fill-generic-text dark:fill-white",
  imageIconClass = "object-cover object-center w-4 h-full",
  summaryBlockItemTextClass = "text-white",
  summaryBlockItemSpacingClass = "py-2 sm:py-0",
  fundSpendingStatus = "",
  sdgIcons = [],
  showFieldworkHours = true,
  showParticipantRatio = true,
  showExperiences = true,
  showTrustPilot = true,
  showTestimonialRating = true,
  showProgramCapacity = true,
  showFundraisingSummary = true
}) => {
  const [reviewsCount, setReviewsCount] = useState(0);
  const programTypesList = programTypes?.nodes ?? programTypes ?? [];
  const programType =
    programTypesList && programTypesList?.length
      ? programTypesList
          ?.filter((item) => item?.title)
          ?.map((pgmType) => {
            return {
              productFieldworkHours:
                pgmType?.acfProgramsType?.productFieldworkHours ?? [],
              productParticipantRatio:
                pgmType?.acfProgramsType?.productParticipantRatio ?? [],
              gviExperiences: pgmType?.acfProgramsType?.gviExperiences ?? []
            };
          })
      : [];

  const productFieldworkHours =
    programType?.length > 0 ? programType[0]?.productFieldworkHours : {};
  const productParticipantRatio =
    programType?.length > 0 ? programType[0]?.productParticipantRatio : {};
  const gviExperiences =
    programType?.length > 0 ? programType[0]?.gviExperiences : {};

  const isUnder18 = programTypeList?.includes("under-18");

  return (
    <div className={`flex flex-row flex-wrap gap-2 ${summaryDetailsClass}`}>
      {(showProgramCapacity ||
        carbonFootprintStatus ||
        programDuration ||
        showFieldworkHours ||
        showParticipantRatio) && (
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-1 sm:gap-8 sm:gap-y-3 sm:items-center font-normal text-base">
          {showProgramCapacity && programPopular && programCapacity && (
            <ProgramCapacity
              programCapacityText={programCapacity}
              outerContainerClass={summaryBlockItemSpacingClass}
            />
          )}

          {carbonFootprintStatus && (
            <div
              className={`carbon-footprint flex justify-left md:justify-between items-center ${summaryBlockItemTextClass} ${summaryBlockItemSpacingClass}`}
            >
              <CarbonFootprintIcon className="w-6 sm:w-8 sm:h-full sm:hidden pr-2" />
              <span
                className={textColorClass}
                dangerouslySetInnerHTML={{
                  __html: carbonFootprintStatus
                }}
              />
            </div>
          )}

          {programDuration && (
            <div
              className={`program-duration flex justify-left md:justify-between ${summaryBlockItemTextClass} ${summaryBlockItemSpacingClass}`}
            >
              <span className={textColorClass}>Durations:&nbsp;</span>
              <span className={textSecondaryColorClass}>{programDuration}</span>
            </div>
          )}

          {showFieldworkHours &&
            productFieldworkHours?.fieldworkDescription?.length > 0 && (
              <div
                className={`fieldwork-hours flex justify-left md:justify-between items-center ${summaryBlockItemTextClass} ${summaryBlockItemSpacingClass}`}
              >
                <Image
                  imageAlt={"Fieldwork hours"}
                  image={""}
                  imageClass={`object-cover object-center w-4 sm:h-full ${imageIconClass}`}
                  sourceUrl={productFieldworkHours?.fieldworkIcon?.sourceUrl}
                />
                <span
                  className={`${textSecondaryColorClass} pl-2`}
                  dangerouslySetInnerHTML={{
                    __html: productFieldworkHours.fieldworkDescription
                  }}
                />
              </div>
            )}

          {showParticipantRatio &&
            productParticipantRatio?.participantDescription?.length > 0 && (
              <div
                className={`participant-ratio flex justify-left md:justify-between items-center ${summaryBlockItemTextClass} ${summaryBlockItemSpacingClass}`}
              >
                <Image
                  imageAlt={"Participant ratio"}
                  image={""}
                  imageClass={`object-cover object-center w-4 sm:h-full ${imageIconClass}`}
                  sourceUrl={
                    productParticipantRatio?.participantIcon?.sourceUrl
                  }
                />
                <span
                  className={`${textSecondaryColorClass} pl-2`}
                  dangerouslySetInnerHTML={{
                    __html: productParticipantRatio.participantDescription
                  }}
                />
              </div>
            )}

          {(showTestimonialRating ||
            showExperiences ||
            showTrustPilot ||
            isUnder18 ||
            showFundraisingSummary) && (
            <>
              {showTestimonialRating && programCode && (
                <GviFlexTestimonialRating
                  iconClass={`object-cover object-center w-4 sm:h-full ${iconClass}`}
                  descClass={`${textSecondaryColorClass} underline`}
                  programCode={programCode}
                  currentBrand={currentBrand}
                  expandedScoreContainerClass={`text-base font-normal ${textColorClass}`}
                  expandedCountContainerClass={`text-base font-normal ${textColorClass}`}
                  containerClass="flex gap-2 sm:gap-2 icon-wrapper justify-items-center items-center cursor-pointer py-2 sm:py-0"
                  layout="new-expanded"
                  scrollToReviews={scrollToReviews}
                  reviewsCount={reviewsCount}
                  setReviewsCount={setReviewsCount}
                />
              )}

              {showFundraisingSummary && programCode && (
                <FundraisingSummary
                  programCode={programCode}
                  currentBrand={currentBrand}
                  iconClass={`w-4 h-full ${iconClass}`}
                />
              )}

              {isUnder18 && (
                <div
                  className={`program-type flex justify-left ${
                    programPopular && programCapacity ? "md:hidden" : ""
                  } text-white`}
                >
                  <span className={`font-bold ${textColorClass}`}>
                    Type:&nbsp;
                  </span>
                  <span className={textColorClass}>{programTypeList}</span>
                </div>
              )}

              {showExperiences &&
                gviExperiences?.experiencesDescription?.length > 0 && (
                  <div className="participant-ratio flex justify-left md:justify-between items-center text-white py-2 sm:py-0 gap-2">
                    <Image
                      imageAlt={"GVI experiences"}
                      image={""}
                      imageClass={`object-cover object-center w-4 sm:h-full ${imageIconClass}`}
                      sourceUrl={gviExperiences?.experiencesIcon?.sourceUrl}
                    />
                    <span
                      className={`${textSecondaryColorClass} pl-2"`}
                      dangerouslySetInnerHTML={{
                        __html: gviExperiences.experiencesDescription
                      }}
                    />
                  </div>
                )}

              {showTrustPilot && (
                <div className="hidden sm:block">
                  <ProgramRating
                    outerContainerClass={"items-center"}
                    darkRatingIconClass={programRatingDarkRatingIconClass}
                    darkRatingLogoClass={programRatingDarkRatingLogoClass}
                  />
                </div>
              )}

              {sdgIcons?.map((sdgIcon, idx) => {
                return (
                  <div
                    key={`sdgIcon-${idx}`}
                    className="flex gap-2 sm:gap-3 icon-wrapper justify-items-center items-center sm:hidden text-white dark:text-gray-dark"
                  >
                    <Image
                      imageClass={
                        "w-7 h-7 block object-cover object-center bg-white dark:bg-gray-dark"
                      }
                      image={sdgIcon?.icon}
                      sourceUrl={sdgIcon?.icon?.sourceUrl}
                    />
                    <div
                      className="text-white dark:text-gray-dark uppercase"
                      dangerouslySetInnerHTML={{
                        __html: ["sdg", sdgIcon?.title].join(" ")
                      }}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}

      {fundSpendingStatus && (
        <div
          className={textColorClass}
          dangerouslySetInnerHTML={{ __html: fundSpendingStatus }}
        />
      )}
    </div>
  );
};

export default ProgramSummaryDetails;
